import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/company-setup')({
  component: () => <RouteGuard route="/company-setup" />,
});
